// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__jWAbY","mask":"Banner_mask__niGLG","title":"Banner_title__RyqXn","desc":"Banner_desc__meHN2"};